// src/components/Layout.tsx
import React from 'react';
import { Layout as AntLayout } from 'antd';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

const { Content } = AntLayout;

/**
 * LayoutWrapper provides the common page layout for authenticated routes.
 * It includes the Header, a content area where nested routes are rendered,
 * and a Footer. Ant Design's Layout component is used for consistent styling.
 * 
 * CRITICAL: The Content div must have a proper height calculation to allow
 * child components like MapView to render correctly with 100% height.
 */
const LayoutWrapper: React.FC = () => {
  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Header />
      <Content style={{ margin: '24px 16px 0', flex: 1, minHeight: 0 }}>
        <Outlet />
      </Content>
      <Footer />
    </AntLayout>
  );
};

export default LayoutWrapper;